<template>
  <el-dialog
    ref="qrDialog"
    :visible.sync="showDialog"
    :before-close="handleClose"
    width="460px">
    <el-tabs class="ui-tabs ui-custom-s" v-model="qrCodeDialogName">
      <el-tab-pane name="订单二维码" class="my-msg">
        <span slot="label" class="lb-txt">订单二维码</span>
        <div class="qrDialog-container">
          <canvas class="qrcode" id="qrcode"></canvas>
          <div>
            <img class="store" src="@/assets/image/store.png" />
            <div class="text">请截图/拍照保存在手机以便现场签到</div>
          </div>
          <div class="bottom">
            <div class="orderName">{{ selectedOrder.goodsName || ''}}</div>
            <div class="orderNumber">订单编号：{{ selectedOrder.orderNumber || '' }}</div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcode'
export default {
  name: 'od-qrcode-dialog',
  props: {
    selectedOrder: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showDialog: this.show,
      qrCodeDialogName: '订单二维码'
    }
  },
  watch: {
    show: function (v) {
      this.showDialog = v
      if (v) {
        this.queryQrCode()
      }
    }
  },
  methods: {
    handleClose (done) {
      this.$emit('qrcodeDialogClose', false)
      done()
    },
    queryQrCode () {
      setTimeout(() => {
        var canvas = document.getElementById('qrcode')
        QRCode.toCanvas(canvas, this.selectedOrder.qr, { width: 200 }, function (error) {
          if (error) console.error(error)
        })
      }, 300)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .qrDialog-container
    width 100%
    height 100%
    text-align center
    .qrcode
      margin-top 4px
      display inline-block
      width 200px
      height 200px
    div
      width 100%
      height 30px
      margin-top 4px
      .store
        line-height 30px
        vertical-align middle
        display inline
        margin-right 4px
      .text
        line-height 30px
        color #31A826
        font-size 14px
        vertical-align middle
        display inline
    .bottom
      width 100%
      height 30px
      margin-top 40px
      display flex
      align-items center
      justify-content space-between
      .orderName
        text-overflow ellipsis
        word-break break-all
        overflow hidden
        white-space nowrap
        color #999999
        font-size 12px
        text-align left
      .orderNumber
        color #999999
        font-size 12px
        text-align right
</style>
